// B1's screens, registered the way every lane registers its own (lane contract C-29): Home (#home), the Action Center
// (#action-center, #action-center/history, ?kind=&tier=&due=&sort=&req=) and Settings (#settings). Each opens behind the manifest tool its
// landing reads, so a person whose manifest lacks it gets the §3.3 not-found screen, never a refused read.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { Home } from "@/views/Home";
import { ActionCenter } from "@/views/ActionCenter";
import { NotFound } from "@/views/NotFound";
import { Settings } from "@/views/Settings";

function HomeRoute({ route }: ViewProps) {
  return createElement(Home, { route });
}

function ActionCenterRoute({ route }: ViewProps) {
  return createElement(ActionCenter, { route });
}

/** #settings is the Settings root; a part under it that no lane registers is the not-found screen, as #compensation's
 * is, never the root over an address it does not answer. */
function SettingsRoute({ route }: ViewProps) {
  return route.parts.length ? createElement(NotFound, { route: route.raw }) : createElement(Settings);
}

registerView("home", HomeRoute, { lane: "B1", gates: ["home.open"] });
registerView("action-center", ActionCenterRoute, { lane: "B1", gates: ["action_center.list"] });
registerView("settings", SettingsRoute, { lane: "B1", gates: ["shell.nav"] });
